module.exports = __webpack_public_path__ + "static/logo-dark-653af8a5dbd7758e9ccc8e36761936bf.svg";